import { makeStyles } from "@material-ui/core/styles";
import { grey, red } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  root: {
    width: "100%",
    border: `1px solid ${palette.primary.main}`,
    borderRadius: spacing(1),
    padding: spacing(1, 2),
    background: "transparent",
    flex: 1,
  },
  collapse: {
    "& button": {
      color: palette.contrastIcon.main,
    },
  },
  row: {
    justifyContent: "space-between",
  },
  contrastText: {
    color: palette.contrastText.main,
  },
  error: {
    border: `1px solid ${red[500]}`,
  },
  actionPanel: {
    width: "auto !important",
  },
  summaryLabel: {
    width: "30%",
    maxWidth: "30%",
    fontSize: "14px",
    lineHeight: 1.5,
    textTransform: "none",
    color: grey[600],
  },
  paymentStatus: {
    padding: spacing(0.5, 1),
    borderRadius: spacing(2),
  },
  blackText: {
    color: "black",
  },
  value: {
    fontSize: "14px",
    fontWeight: 500,
  },
  bold: {
    fontWeight: 600,
  },
}));

export default styles;
